import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Input } from 'reactstrap';
import './index.scss';

const SearchBlock = ({ _change, _keyword }) => {
	const [keyword, setKeyword] = useState('')


	const handleKeypress = (e) => {
		if ((e.which < 48 || e.which > 57)) {
		  e.preventDefault();
		}
	  }

	return (
		<div className='search-blc position-relative'>
			<Input type="number" value={keyword} placeholder="Transaction Id" onChange={(e) => { if (!e.target.value) _change(e.target.value); setKeyword(e.target.value) }}
				onKeyDown={(e) => { if (e.key === 'Enter') _change(keyword) }} 
				onKeyPress={handleKeypress}
				/>
			<span className='position-absolute d-inline-flex align-items-center justify-content-center'>
				<FontAwesomeIcon icon={faSearch} />
			</span>
		</div>
	);
}

export default SearchBlock;